// Shim for react-bootstrap v0.32.x MenuItem component (removed in v2)
// Provides API compatibility wrapper for Dropdown.Item in v2
import React from 'react'
import { Dropdown } from 'react-bootstrap'

interface MenuItemProps {
  eventKey?: string | number
  onSelect?: (eventKey: any, event: any) => void
  disabled?: boolean
  divider?: boolean
  header?: boolean
  children?: React.ReactNode
  [key: string]: any
}

// Compatibility wrapper that translates v0.32.x MenuItem API to v2 Dropdown API
const MenuItemShim: React.FC<MenuItemProps> = ({
  eventKey,
  onSelect,
  disabled,
  divider,
  header,
  children,
  ...rest
}) => {
  // Handle divider case - use Dropdown.Divider (no li wrapper needed)
  if (divider) {
    return <Dropdown.Divider {...rest} />
  }

  // Handle header case - use Dropdown.Header (no li wrapper needed)
  if (header) {
    return <Dropdown.Header {...rest}>{children}</Dropdown.Header>
  }

  // Regular item - translate onSelect to onClick and wrap in li for CSS compatibility
  const handleClick = onSelect
    ? (e: React.MouseEvent) => {
        e.preventDefault()
        onSelect(eventKey, e)
      }
    : undefined

  return (
    <li>
      <Dropdown.Item eventKey={eventKey} onClick={handleClick} disabled={disabled} {...rest}>
        {children}
      </Dropdown.Item>
    </li>
  )
}

// Export both default and named to handle different import styles
export default MenuItemShim
export const MenuItem = MenuItemShim
